import { ChatSection } from "@/components/ChatSection";
import { FeaturesSection } from "@/components/FeaturesSection";
import { GettingStartedSection } from "@/components/GettingStartedSection";
import { PurchaseSection } from "@/components/PurchaseSection";
import { ReceiverSection } from "@/components/ReceiverSection";
import { initSoundEffects } from "@/services/SoundEffects";
import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/_layout/")({
	component: Home,
});

function Home() {
	// Initialize sound effects
	useEffect(() => {
		initSoundEffects();
	}, []);

	return (
		<div className="flex min-h-[calc(100vh-240px)] flex-col items-center justify-center">
			{/* Hero Section */}
			<div className="w-full max-w-3xl space-y-8 text-center">
				{/* Marketing Content */}
				<div className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-0 mb-6 mx-auto">
					<div className="flex-shrink-0">
						<video
							poster="/images/demo.avif"
							autoPlay
							loop
							playsInline
							muted
							className="w-100 md:w-100 lg:w-120 h-auto rounded-lg"
							width="970"
							height="970"
						>
							<source src="/videos/demo.mp4" type="video/mp4" />
							<img
								src="/images/demo.webp"
								alt="Macrowave app demo video fallback"
								width="970"
								height="970"
							/>
						</video>
					</div>
					<div className="text-center md:text-left">
						<h1 className="text-2xl md:text-4xl lg:text-6xl mb-1 font-serif-600">
							Macrowave
						</h1>
						<h2 className="text-base md:text-lg lg:text-2xl leading-relaxed font-serif text-gray-500">
							Turn Your Mac/iPhone Into a Private Radio Station
						</h2>
						<a
							href="https://apps.apple.com/app/apple-store/id6746954963?pt=123127751&ct=macrowave.co&mt=8"
							target="_blank"
							rel="noopener noreferrer"
							className="inline-block mt-4"
						>
							<img
								src="/images/app-store-badge.svg"
								alt="Download on the App Store"
								width="120"
								height="40"
								className="h-10"
							/>
						</a>
					</div>
				</div>

				<FeaturesSection />

				<ReceiverSection />
				
				<GettingStartedSection />
				
				<ChatSection />

				<PurchaseSection />
			</div>
		</div>
	);
}
